// Upload one file to attach to a question. Resolves to
// { id, name, kind, mime, size, url }; rejects with an ApiError whose message
// can be shown as is.

import { ApiError, reportUnauthorized } from './api.js'

export async function uploadFile(file, { signal } = {}) {
  const form = new FormData()
  form.append('file', file, file.name || 'pasted-image.png')
  let response
  try {
    response = await fetch('/api/uploads', { method: 'POST', body: form, credentials: 'same-origin', signal })
  } catch (cause) {
    if (cause?.name === 'AbortError') throw cause
    throw new ApiError(0, 'network', "Couldn't upload. Check your connection and try again.")
  }
  const data = await response.json().catch(() => null)
  if (!response.ok) {
    const error = new ApiError(
      response.status,
      data?.error?.code ?? 'http_error',
      data?.error?.message ?? `Upload failed (${response.status}).`,
    )
    if (response.status === 401) reportUnauthorized(error)
    throw error
  }
  return data.upload
}
